import React, { useState } from 'react';

const CLAVE = 'novodka';

const CONTACTOS = [
  { nombre: 'Karina',   telefono: '+54 9 370 4824997' },
  { nombre: 'Die',      telefono: '+54 9 370 4304489' },
  { nombre: 'Iru',      telefono: '+54 9 370 4328898' },
  { nombre: 'Sofi',     telefono: '+54 9 370 4341828' },
  { nombre: 'Male',     telefono: '+54 9 370 4715716' },
  { nombre: 'Malenix',  telefono: '+54 9 370 5035809' },
  { nombre: 'Kike',     telefono: '+54 9 370 4598493' },
  { nombre: 'AbuLito',  telefono: '+54 9 11 62175214' },
  { nombre: 'AbuMari',  telefono: '+54 9 11 68578853' },
  { nombre: 'Taia',     telefono: '+54 9 370 4255655' },
];

export default function Franco() {
  const [input, setInput] = useState('');
  const [desbloqueado, setDesbloqueado] = useState(
    () => sessionStorage.getItem('fp_franco') === '1'
  );
  const [error, setError] = useState(false);

  const verificar = (e) => {
    e.preventDefault();
    if (input.trim().toLowerCase() === CLAVE) {
      sessionStorage.setItem('fp_franco', '1');
      setDesbloqueado(true);
      setError(false);
    } else {
      setError(true);
      setInput('');
    }
  };

  if (!desbloqueado) {
    return (
      <div style={estilos.fondo}>
        <div style={estilos.card}>
          <div style={estilos.icono}>🔒</div>
          <h2 style={estilos.titulo}>Página privada</h2>
          <p style={estilos.sub}>Ingresá la contraseña para continuar</p>
          <form onSubmit={verificar} style={{ width: '100%' }}>
            <input
              type="password"
              value={input}
              onChange={e => { setInput(e.target.value); setError(false); }}
              placeholder="Contraseña"
              autoFocus
              style={{ ...estilos.input, borderColor: error ? '#e74c3c' : '#ddd' }}
            />
            {error && <p style={estilos.errorMsg}>Contraseña incorrecta</p>}
            <button type="submit" style={estilos.btn}>Entrar</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={estilos.fondo}>
      <div style={{ ...estilos.card, maxWidth: 480 }}>
        <div style={estilos.icono}>📱</div>
        <h2 style={estilos.titulo}>Contactos de Franco</h2>
        <p style={estilos.sub}>Por si perdés el celu 😄</p>
        <div style={{ width: '100%', marginTop: 16 }}>
          {CONTACTOS.length === 0 && (
            <p style={{ textAlign: 'center', color: '#999' }}>
              (pronto van a aparecer los contactos acá)
            </p>
          )}
          {CONTACTOS.map((c, i) => (
            <div key={i} style={estilos.fila}>
              <span style={estilos.nombre}>{c.nombre}</span>
              <a href={`tel:${c.telefono.replace(/\s/g, '')}`} style={estilos.tel}>
                {c.telefono}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const estilos = {
  fondo: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f5f5',
    padding: '20px',
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    padding: '40px 32px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 360,
  },
  icono: {
    fontSize: 48,
    marginBottom: 12,
  },
  titulo: {
    margin: '0 0 4px',
    fontSize: 22,
    fontWeight: 700,
    color: '#222',
  },
  sub: {
    margin: '0 0 20px',
    color: '#666',
    fontSize: 14,
    textAlign: 'center',
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    fontSize: 16,
    border: '2px solid #ddd',
    borderRadius: 8,
    outline: 'none',
    boxSizing: 'border-box',
    marginBottom: 8,
  },
  errorMsg: {
    color: '#e74c3c',
    fontSize: 13,
    margin: '0 0 8px',
    textAlign: 'center',
  },
  btn: {
    width: '100%',
    padding: '12px',
    background: '#2c3e50',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 4,
  },
  fila: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '14px 0',
    borderBottom: '1px solid #f0f0f0',
  },
  nombre: {
    fontWeight: 600,
    color: '#333',
    fontSize: 15,
  },
  tel: {
    color: '#2980b9',
    textDecoration: 'none',
    fontSize: 15,
    fontWeight: 500,
  },
};
